import { basicService } from "@/services/basic.service";
import { basicShareService } from "@/services/basicShare.service";
import ACTIONCODE from '@/config/actionCode.env';
import TABLE_NAME from "@/config/table.env";
const tableName = TABLE_NAME.QUANTRI_QUYEN
const typeForm = 0;
const typeJson = 1;
const actions = {

    //Get Data

    async getBasicQuyenQT({ dispatch }, { params }) {
        params.ACTIONCODE = ACTIONCODE.SELECTBASICLIST
        return await basicShareService.queryData(params, tableName).then(
            (resp) => {
                if (resp.statusCode == 200) {

                    return resp.data;
                }
                else {
                    dispatch("alert/warning", "Không tồn tại dữ liệu", { root: true });
                    return null;
                }
            },
            (error) => {
                console.log(error.message);
                dispatch("alert/error", "Có lỗi trong quá trình lấy dữ liệu", { root: true });
                return null;
            }
        );
    },






    //Change Data

    



    //Customs

};


export const quyenQT = {
    namespaced: true,
    actions,
};
